__turbopack_context__.v({
  "messageIcon": "HwmAGa_messageIcon",
  "messageIconWrapper": "HwmAGa_messageIconWrapper",
});
